import { api } from '../../lib/api';
import { T, useGym } from '../../lib/gym';
import { useApi } from '../../lib/hooks';
import { useI18n } from '../../lib/i18n';
import { Card, Empty, ErrorBox, Loading, PageHeader, cx } from '../../ui/components';

/** A member's own body measurements from the gym's analyser. */
export function MyBodyPage() {
  const gym = useGym();
  const i18n = useI18n();
  const data = useApi(() => api<any>(`${T(gym.slug)}/me/measurements`), []);
  const activity = useApi(() => api<any>(`${T(gym.slug)}/me/activity`), []);
  if (data.error) return <div className="page"><ErrorBox error={data.error} onRetry={data.reload} /></div>;
  if (!data.data) return <Loading />;
  const { latest, change, measurements } = data.data;
  return (
    <div className="page narrow">
      <PageHeader title={i18n.t('body.my_title')} subtitle={latest ? i18n.t('body.my_since', { date: i18n.date(data.data.since) }) : undefined} />
      {!latest ? <Empty icon="⚖">{i18n.t('body.my_none')}</Empty> : (
        <>
          <Card>
            <div className="stats">
              <div className="stat"><div className="stat-label">{i18n.t('body.weight')}</div><div className="stat-value">{latest.weightKg ?? '—'} kg</div>
                {change.weightKg !== null && <div className={cx('small', change.weightKg < 0 ? 'good' : 'muted')}>{change.weightKg > 0 ? '+' : ''}{change.weightKg} kg</div>}</div>
              <div className="stat"><div className="stat-label">{i18n.t('body.fat')}</div><div className="stat-value">{latest.bodyFatPercent ?? '—'}%</div></div>
              <div className="stat"><div className="stat-label">{i18n.t('body.muscle')}</div><div className="stat-value">{latest.skeletalMuscleKg ?? '—'} kg</div>
                {change.skeletalMuscleKg !== null && <div className={cx('small', change.skeletalMuscleKg > 0 ? 'good' : 'muted')}>{change.skeletalMuscleKg > 0 ? '+' : ''}{change.skeletalMuscleKg} kg</div>}</div>
            </div>
          </Card>
          <Card title={i18n.t('body.history')}>
            <table className="table">
              <thead><tr><th>{i18n.t('body.date')}</th><th>{i18n.t('body.weight')}</th><th>{i18n.t('body.fat')}</th><th>{i18n.t('body.muscle')}</th></tr></thead>
              <tbody>
                {measurements.map((m: any) => (
                  <tr key={m.id}>
                    <td data-label={i18n.t('body.date')}>{i18n.date(m.measuredAt)}</td>
                    <td data-label={i18n.t('body.weight')}>{m.weightKg ?? '—'}</td>
                    <td data-label={i18n.t('body.fat')}>{m.bodyFatPercent ?? '—'}</td>
                    <td data-label={i18n.t('body.muscle')}>{m.skeletalMuscleKg ?? '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
          {activity.data && activity.data.days.length > 0 && (
        <Card title={i18n.t('phone.title')}>
          <div className="stats">
            <div className="stat"><div className="stat-label">{i18n.t('phone.steps')}</div><div className="stat-value">{activity.data.averages.steps ?? '—'}</div><div className="small muted">{i18n.t('phone.per_day')}</div></div>
            <div className="stat"><div className="stat-label">{i18n.t('phone.exercise')}</div><div className="stat-value">{activity.data.averages.exerciseMinutes ?? '—'}</div><div className="small muted">{i18n.t('phone.min_per_day')}</div></div>
            <div className="stat"><div className="stat-label">{i18n.t('phone.active_days')}</div><div className="stat-value">{activity.data.activeDays}</div><div className="small muted">{i18n.t('phone.of_days', { days: activity.data.window })}</div></div>
          </div>
          <p className="small muted">{i18n.t('phone.from_phone')}</p>
        </Card>
      )}
      <p className="small muted">{i18n.t('body.my_help')}</p>
        </>
      )}
    </div>
  );
}
